import Button from './Button';
import Icon from '../icons/Icon';
import IconCloseCross from '../icons/IconCloseCross';
import React from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';

const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContainer = styled(motion.div)`
  background: white;
  border-radius: 8px;
  padding: 30px 20px 20px 20px;
  width: 90%;
  max-width: 400px;
  position: relative;
  box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.38);
`;

const ModalContent = styled.div`
  text-align: center;
`;

const Message = styled.div`
  font-size: 1.6rem;
  font-weight: 600;
  color: #333;
  margin: 20px;
  line-height: 1.4;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AlertModal = props => {
  const { onClose, onButtonClick, open, theme, message, buttonText } = props;

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else {
      onClose();
    }
  };

  return (
    <AnimatePresence>
      {open && (
        <ModalOverlay
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={handleOverlayClick}
        >
          <ModalContainer
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
          >
            <CloseButton onClick={onClose}>
              <Icon
                icon={IconCloseCross}
                width={'20px'}
                height={'20px'}
                color={theme.mainColor}
              />
            </CloseButton>

            <ModalContent>
              <Message>
                {message}
              </Message>

              <Button btntype={'primary'} onClick={handleButtonClick}>
                {buttonText}
              </Button>
            </ModalContent>
          </ModalContainer>
        </ModalOverlay>
      )}
    </AnimatePresence>
  );
};

export default AlertModal;
